export const ANSWER_REVIEW_STATUS_NOT_PASSED = '30'



// WEBPACK FOOTER //
// ./src/views/question-review/question-review.constants.js